module.exports = __webpack_public_path__ + "img/logo_muten_white.a4ba8a12.svg";